import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { ToReviewFundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrieveToReviewFundingRequests } from "./retrieve-to-review-funding-requests";

const initialState: RetrievalState<ToReviewFundingRequestVM[]> = {
  fetching: "idle",
  data: [],
};

export const retrieveToReviewFundingRequestsReducer = createReducer<RetrievalState<ToReviewFundingRequestVM[]>>(initialState, builder => {
  builder.addCase(retrieveToReviewFundingRequests.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveToReviewFundingRequests.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveToReviewFundingRequests.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
